import { Box, Button, Grid, Typography } from '@mui/material'
import { useLayoutEffect, useState, useContext, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useLocation } from 'react-router'
import { BaseInput, BreadCrumb, SnackSimple } from '../../../../components'
import StatusComponent from '../../../../components/status'
import SimpleModal from '../../../../components/modal/simpleModal'
import { GlobalContext } from '../../../../contexts/Global'
import { getStatus } from '../../../../hooks/status'
import { useContextState } from '../../../../hooks/theme'
import { actionPlansServices } from '../../../../service/actionPlans'
import { httpFetch } from '../../../../utils/crud'
import { RequestErrors, Roles, Status, Types } from '../../../../utils/enums'
import { onChange } from '../../../../utils/types'
import { Item, ObjectGeneric } from '../../../../utils/types/generals'
import { useStyles } from './styles'
import { getDirectManagement } from '../../../../utils/methods/getDirectMangement'
import { getUserRole } from '../../../../service/auth'
import { CustomPaper } from '../../../../components/CustomPaper'
import Left from './fragments/left'
import Right from './fragments/right'
import { CardItem, ViewMode } from './fragments/left/type'
import { handleAllErrors } from '../../../../utils/methods/handleErrors'
import { ActionPlanDetail, UpdateApproverList } from './type'
import BaseModal from '../../../../components/modal/baseModal'
import { LoadingButton } from '@mui/lab'
import Loader from '../../../../components/loader'
import TimeOut from './components/modals/timeOut'
import Reassign from './fragments/reassign'
import { getArea, getDepartments, getUserTypes } from '../../../../utils/methods/geServiceWithItemsFormat'
import { actionPlan, ActionPlanAnswer } from '../../../../service/actionPlans/actionPlanById'
import { actionPlanFetch } from '../../../../utils/constants/callService'
import dayjs from 'dayjs'
import { Constants } from '../../../../utils/constants'
import { HeaderQuestionnaire } from '../../../../components/headerQuestionnaire'
import { NavigatioStateType } from '../../../../utils/enums/navigatetionState'
import { BreadCrumbKeys, BreadcrumbTypes } from '../../../../components/breadCrumb/enum'
import { QuestionnaireProps } from '../../../../components/headerQuestionnaire/types'
import { getLocalStorage } from '../../../../utils/crud/crypt'

const Form = () => {
  const { state } = useContext(GlobalContext)
  const stateLocale = getLocalStorage<ObjectGeneric>()
  const { role } = state
  const loaction = useLocation()
  const [blockActions, setBlockActions] = useState<{
    cancel: boolean;
    reassign: boolean;
    approveOrReject: boolean;
  }>()
  const [headerScheduleDetail, setHeaderScheduleDetail] = useState<QuestionnaireProps>()
  const { id } = useParams()
  const { colors } = useContextState()
  const { t } = useTranslation()
  const [modalWarning, setModalWarning] = useState({
    open: false,
    message: '',
  })
  const [btnLoading, setBtnLoading] = useState(false)
  const [allData, setAllData] = useState<actionPlan & {
    evidences: {
      status: {
        value: Status;
        color: string;
        text: string;
      }
    }
  } | null>(null)
  const [showMore, setShowMore] = useState({
    detail: false,
    reject: false,
  })
  const timeZone = useMemo(() => allData?.store ? allData?.store?.timeZone ?? Constants.defaultTimeZone : undefined, [allData?.store])
  const [endDate, setEndDate] = useState('')
  const [startDate, setStartDate] = useState('')
  const [rejectDisable, setRejectDisable] = useState<boolean>(false)
  const [aproveDisable, setAproveDisable] = useState<boolean>(false)
  const [actionPlanAnswers, setActionPlanAnswers] = useState<ActionPlanAnswer[]>([])
  const [timeOutModal, setTimeOutModal] = useState({ open: false, title: '' })
  const [actionPlan, setActionPlan] = useState<ActionPlanDetail>()
  const [isLoading, setIsLoading] = useState(true)
  const [isLoadingConfirm, setIsLoadingConfirm] = useState(false)
  const [data, setData] = useState<ObjectGeneric>({ reject: '' })
  const [openReassignActionPlan, setOpenReassignActionPlan] = useState(false)
  const [errors, setErrors] = useState<ObjectGeneric>({ reject: '' })
  const [openSnackbar, setOpenSnackbar] = useState({
    open: false,
    type: Types.SUCCESS,
    message: '',
  })
  const [usersFound, setUsersFound] = useState<Item[]>([])
  const [filterItems, setFilterItems] = useState<{
    area: Item[],
    department: Item[],
    userType: Item[]
  }>({
    area: [],
    department: [],
    userType: []
  })
  const [userCreator, setUserCreator] = useState<CardItem>()
  const [userAssigned, setUserAssigned] = useState<CardItem>()
  const [store, setStore] = useState<CardItem>()
  const answer = useMemo(() => {
    const actionPlanLength = allData?.actionPlanAnswers?.length ?? 1
    return allData?.actionPlanAnswers?.[actionPlanLength - 1]
  }, [allData?.actionPlanAnswers])
  const [approverUsers, setApproverUser] = useState<Item[]>([])

  const mode = useMemo<ViewMode>(() => {
    const type = allData?.typeActionPlan?.toLowerCase()
    if (type === 'automatic' || type === 'automatic_later') return 'questions-only'
    if (allData?.isPerQuestionnaire) return 'items-only'
    return 'items-single-question'
  }, [allData])

  const styles = useStyles({ colors, status: allData?.evidences?.status })
  const isAdmin = state.role === Roles.ADMIN
  const onChange: onChange = ({ target }) => {
    const { name, value } = target

    setData((prev) => ({
      ...prev,
      [name]: value,
    }))

    setErrors((prev) => ({
      ...prev,
      [name]: !value ? t('general.validations.required') : '',
    }))
  }
  const [canReassgn, setCanReassign] = useState(false)
  const openReassign = () => {
    setOpenReassignActionPlan(true)
  }
  const closeReassign = () => {
    setOpenReassignActionPlan(false)
  }
  const updateAproverList: UpdateApproverList = ({ approverUsers }) => {
    setApproverUser(approverUsers)
  }

  const getAllApprovers = async () => {
    const response = await actionPlanFetch.getApprovers({})
    if (!response?.errors) {
      if (response.length) {
        setUsersFound(response?.map(approver => ({
          label: `${approver.firstName ?? ''} ${approver.lastName ?? ''}`.trim(),
          value: approver.id,
          id: approver.id?.toString(),
          email: approver.email,
          curp: approver.curp,
          role: approver.role
        })))
        return
      }
      return
    }
  }
  const getActionPlanById = () => {
    setIsLoading(true)
    if (id) {
      actionPlansServices(httpFetch)
        .getById(parseInt(id))
        .then((response) => {
          const isCreator = state?.id == response.userCreatorId
          const isAdmin = state.role == Roles.ADMIN
          setActionPlan({
            title: response.templateName ?? '',
            item: response?.items?.map(item => ({ question: item.question ?? '', answer: item.agentAnswer ?? '', id: item.id?.toString() ?? '' })) || []
          })
          const timeZone = response?.store ? response?.store?.timeZone ?? Constants.defaultTimeZone : undefined
          setEndDate(dayjs(response.finishDate).tz(timeZone).locale('es').format(Constants.dayjsFormat))
          setStartDate(dayjs(response.startDate).tz(timeZone).locale('es').format(Constants.dayjsFormat))
          const mappedApprovers = response?.usersApprovers?.map(approver => ({
            label: approver.fullName ?? `${approver.firstName ?? ''} ${approver.lastName ?? ''}`.trim(),
            value: approver.id,
            email: approver.email,
            id: approver.id.toString()
          })) || []
          const isManualModule = response.typeActionPlan?.toLowerCase() === 'manual_module'
          const creator = response.userCreator
          setApproverUser(
            isManualModule && !mappedApprovers.length && creator?.id
              ? [{ label: creator.fullName ?? '', value: creator.id, email: creator.email ?? '', id: creator.id.toString() }]
              : mappedApprovers
          )
          setCanReassign(isCreator || isAdmin)
          setTimeOutModal(() => ({
            open: (isCreator || isAdmin) && !!response?.usersApprovers?.length && !!response.stringMaximumWaitingTimeActionPlan && ![Status.REJECTED, Status.APPROVED, Status.EXPIRED].includes(response.statusId as Status),
            title: response.stringMaximumWaitingTimeActionPlan ?? ''
          }))
          if (response.userCreator?.id) {
            setUserCreator({
              label: response.userCreator?.fullName ?? '',
              date: response.create_time,
            })
          }
          if (response.userAssign?.id) {
            setUserAssigned({
              label: response.userAssign?.fullName ?? '',
              footer: response.userAssign.curp ?? '',
              date: response.create_time,
              email: response.userAssign.email ?? '',
            })
          }
          setStore(
            response?.store
              ? {
                  label: `${response.store.keyCode} - ${response.store.name}`,
                  footer: `${t('general.tags.manager')}: ${response.store.userManageName ?? 'N/A'}`,
                  timeZone: response.store.storeTimeZone?.zone ?? Constants.defaultTimeZoneZone,
                }
              : undefined
          )
          setActionPlanAnswers(response?.actionPlanAnswers?.reverse() || [])
          setAllData({
            ...response,
            evidences: {
              status: getStatus(response.statusId as Status, colors, t),
            },
          })
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      setIsLoading(false)
    }
  }



  const showCancel = () => {
    if (blockActions?.cancel) { return true }
    if (![Roles.ADMIN, Roles.AGENT, Roles.SUPERVISOR, Roles.GERENT].includes(role as Roles)) return true
    if (stateLocale.id !== allData?.userCreatorId && role !== Roles.ADMIN) return true
    return !!(
      !!answer ||
      (allData && [Status.APPROVED, Status.REJECTED, Status.CANCEL, Status.INACTIVE, Status.EXPIRED]?.includes(allData?.statusId as Status)) ||
      (allData?.actionPlanAnswers && allData?.actionPlanAnswers?.length > 1)
    )
  }

  const showRejected = ({ status, rejects = 0 }: { status?: number; rejects?: number }) => {
    if (blockActions?.approveOrReject) { return true }
    const myRole = getUserRole() as Roles
    const answerActionPlan = allData?.actionPlanAnswers

    const iAmLevelUp = myRole === Roles.ADMIN || getDirectManagement(allData?.userCreator?.roleId as Roles)?.includes(myRole) || (!timeOutModal.title && approverUsers?.some(approver => approver.id == state.id))
    const isAStatusAvailable = ![Status.APPROVED, Status.REJECTED, Status.AWAIT_SOLUTION].includes(status as Status)
    // const theDateIsNotExpired = (allData?.finishDate && new Date(allData?.finishDate).getTime() <= Date.now())
    const theMaxOfRejectsDidnotBeCatched = !!answerActionPlan && answerActionPlan?.filter((item) => item.statusId == Status.REJECTED)?.length >= rejects
    const isRespondedStatus = status == Status.RESPONDED
    const isCreatedByMySelf = (allData?.userCreatorId) == stateLocale?.id
    const iAmApprover = approverUsers?.some(a => a.id == state.id)
    if (isCreatedByMySelf && !iAmApprover && (!allData?.maxApprovalDate || dayjs(allData?.maxApprovalDate).tz(timeZone).isAfter(dayjs())) && !!approverUsers?.length) { return false }
    return (!!iAmLevelUp || !!isCreatedByMySelf) && ((!!isAStatusAvailable) && !!(!theMaxOfRejectsDidnotBeCatched && isRespondedStatus))
  }

  const handleSnackbar = (status: Types, name: string, type: string, code?: string) => {
    setOpenSnackbar({
      open: true,
      type: status,
      message: code ? handleAllErrors(code as RequestErrors, t,) : t(`actionPlan.snackbar.${name}.${type}`),
    })
  }

  const approvedActionPlan = async (id: number) => {
    setAproveDisable(true)
    const response = await actionPlansServices(httpFetch).approve([{ id, reason: '' }])
    if (!response.errors) {
      getActionPlanById()
      handleSnackbar(Types.SUCCESS, 'approved', 'success')
    } else {
      handleSnackbar(Types.ERROR, 'approved', 'error')
    }
    setAproveDisable(false)
  }
  const cancelActionPlan = async () => {
    if (id) {
      setBtnLoading(true)
      const response = await actionPlansServices(httpFetch).cancel({ actionPlanImplementedId: parseInt(id) })
      if (!response.errors) {
        getActionPlanById()
        handleSnackbar(Types.SUCCESS, 'cancel', 'success')
      } else {
        handleSnackbar(Types.ERROR, 'cancel', 'error', response?.errors?.[0]?.code)
      }
      setBtnLoading(false)
      closeModal(true)
    }
  }
  const rejectActionPlan = async () => {
    if (id) {
      setIsLoadingConfirm(true)
      const response = await actionPlansServices(httpFetch).reject({ id: parseInt(id), reasonRejection: data.reject })
      if (!response.errors) {
        getActionPlanById()
        handleSnackbar(Types.SUCCESS, 'reject', 'success')
      } else {
        handleSnackbar(Types.ERROR, 'reject', 'error')
      }
      setIsLoadingConfirm(false)
      handleCloseModal()
    }
  }

  const handleCloseModal = () => {
    setShowMore((prev) => ({
      ...prev,
      reject: false,
    }))

    setData({})
    setErrors({})
  }

  const handleCloseSnackbar = () => {
    setOpenSnackbar((prev) => ({
      ...prev,
      open: false,
    }))
  }

  const closeModal = (close?: boolean) => {
    setModalWarning({
      open: !close,
      message: t('actionPlan.modal.cancel'),
    })
  }

  const closeTimeModal = () => {
    setTimeOutModal(prev => ({ ...prev, open: false }))
  }

  const getAreas = useCallback(async () => {
    const item = await getArea()
    setFilterItems(prev => ({ ...prev, area: item }))
  }, [])
  const getDepartment = useCallback(async () => {
    const item = await getDepartments()
    setFilterItems(prev => ({ ...prev, department: item }))
  }, [])
  const getUserType = useCallback(async () => {
    const item = await getUserTypes()
    setFilterItems(prev => ({ ...prev, userType: item.items }))
  }, [])
  const reassignActionPlan = () => {
    closeTimeModal()
    openReassign()
  }

  useLayoutEffect(() => {
    getActionPlanById()
    getAreas()
    getAllApprovers()
    getDepartment()
    getUserType()
  }, [getUserType, getDepartment, getUserType])


  const headerFronSchedule = () => {
    const state = loaction.state
    if ([NavigatioStateType.SCHEDULE, NavigatioStateType.USER_SCHEDULE, NavigatioStateType.SCHEDULE_RECURRENCE, NavigatioStateType.USER_RECURRENCE].includes(state?.type)) {
      setHeaderScheduleDetail({
        answerList: [{ label: state?.item ?? '' }],
        question: state?.question ?? '',
        title: state?.title ?? '',
        parentId: state?.parentId,
        version: state?.version,
      })
    }
  }

  const navigationActions = () => {
    const queary = new URLSearchParams(loaction.search)
    const actions = queary.get(BreadCrumbKeys.ACTIONS)
    setBlockActions({
      cancel: actions == BreadcrumbTypes.BLOCK_All_ACTIONS,
      reassign: actions == BreadcrumbTypes.BLOCK_All_ACTIONS,
      approveOrReject: actions == BreadcrumbTypes.BLOCK_All_ACTIONS,
    })
  }

  useLayoutEffect(() => {
    navigationActions()
    headerFronSchedule()
  }, [])

  const creationTypeKey = useMemo(() => {
    const type = allData?.typeActionPlan?.toLowerCase()
    if (type === 'automatic' || type === 'automatic_later') return 'actionPlan.creationType.automatic'
    if (type === 'manual_module') return 'actionPlan.creationType.manualLabel'
    return 'actionPlan.creationType.manualByExecution'
  }, [allData?.typeActionPlan])

  const isAutomaticMode = useMemo(() => {
    const type = allData?.typeActionPlan?.toLowerCase()
    return type === 'automatic' || type === 'automatic_later'
  }, [allData?.typeActionPlan])

  const showReassignButton = useMemo(() => {
    return (
      !isAutomaticMode &&
      !!(approverUsers?.length) &&
      !!allData?.evidences?.status?.value &&
      ![Status.REJECTED, Status.APPROVED, Status.EXPIRED].includes(allData.evidences.status.value) &&
      canReassgn &&
      !blockActions?.reassign
    )
  }, [isAutomaticMode, approverUsers, allData?.evidences?.status, canReassgn, blockActions?.reassign])

  return (
    <Box sx={styles.container}>
      <BreadCrumb
        removeBreadcrumb={['calendar', 'schedule-user']}
        replaceLabels={{ createdEdit: 'actionPlanCreatedEdit' }}
        replacePath={{ 'action-plan': '/dashboard/action-plan/created' }}
      />

      {
        !!headerScheduleDetail && (
          <HeaderQuestionnaire {...headerScheduleDetail} />
        )
      }
      {!!isLoading && (<Loader />)}

      {
        !isLoading && (
          <CustomPaper sx={styles.containerFragments}>
            <Box sx={styles.header}>
              <Box sx={styles.headerTitles}>
                <Typography sx={styles.headerTitle}>{actionPlan?.title ?? allData?.templateName ?? t('actionPlan.actionPlanTitle')}</Typography>

                <Typography sx={styles.headerSubtitle}>
                <strong>{t('actionPlan.creationTypeLabel')}: </strong>{t(creationTypeKey)}
                </Typography>
              </Box>

              <Box sx={styles.statusContainer}>
                <StatusComponent
                  size="small"
                  fit
                  color={allData?.evidences?.status?.color ?? ''}
                  msg={allData?.evidences?.status?.text ?? ''}
                  type="chip"
                />
                {!isAdmin && !!allData?.attentionType && (
                  <StatusComponent
                    size="small"
                    fit
                    color={colors.color10 ?? ''}
                    msg={allData?.attentionType}
                    type="chip"
                  />
                )}
              </Box>
            </Box>

            <Grid container columnSpacing={2} sx={styles.mainGrid}>
              <Grid item xl={3} lg={4} md={12} sm={12} xs={12} sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <Left
                  mode={mode}
                  status={allData?.evidences?.status}
                  userCreator={userCreator}
                  userAssigned={userAssigned}
                  store={store}
                  approverUsers={approverUsers}
                  typeActionPlan={allData?.typeActionPlan}
                  canAnswer={allData?.canAnswer}
                  endDate={endDate}
                  startDate={startDate}
                  createDate={allData?.create_time}
                  stoper={!!allData?.stopTimer}
                  cancelLoading={btnLoading}
                  reportUrl={allData?.reportUrl}
                  showCancelActionPlan={!showCancel()}
                  showReassignButton={showReassignButton}
                  openReassign={openReassign}
                  cancelActionPlan={cancelActionPlan}
                />
              </Grid>

              <Grid item xl={9} lg={8} md={12} sm={12} xs={12} sx={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                {
                  !openReassignActionPlan && (
                    <Right
                      mode={mode}
                      items={actionPlan?.item}
                      detailCreation={allData?.detailCreation}
                      detailQuestions={allData?.detailQuestions}
                      isManualModule={allData?.isManualModule}
                      description={allData?.description}
                      evidences={allData?.actionPlanEvidence}
                      id={allData?.id}
                      answerActionPlan={actionPlanAnswers || []}
                      aproveDisable={aproveDisable}
                      showActions={allData?.statusId !== Status.APPROVED && !!showRejected({ status: allData?.statusId, rejects: allData?.maxRejections })}
                      onApprove={() => { if (id) { approvedActionPlan(parseInt(id)) } }}
                      onReject={() => { setShowMore((prev) => ({ ...prev, reject: true })) }}
                    />
                  )
                }

                {
                  !!openReassignActionPlan && !blockActions?.reassign && (
                    <Reassign
                      setUsersFound={setUsersFound}
                      usersFound={usersFound}
                      updateAproverList={updateAproverList}
                      close={closeReassign}
                      userList={approverUsers}
                      filterItems={filterItems}
                    />
                  )
                }
              </Grid>
            </Grid>
          </CustomPaper>
        )
      }

      <TimeOut
        action={reassignActionPlan}
        title={timeOutModal.title}
        close={closeTimeModal}
        modalProps={{
          open: timeOutModal.open && canReassgn,
        }}
      />

      <SimpleModal
        open={modalWarning.open}
        description=""
        close={() => {
          closeModal(true)
        }}
        title={modalWarning.message}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        color={colors}
        back={() => {
          closeModal(true)
        }}
        loadingButton
        isLoading={btnLoading}
        next={() => {
          cancelActionPlan()
        }}
      />
      <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />

      <BaseModal open={showMore.reject}>
        <>
          <Grid container rowSpacing={2} p={5}>
            <Grid item xl={12} lg={12} md={12} sm={12}>
              <Typography sx={styles.rejectTitle}>{t('actionPlan.modal.title')}</Typography>
            </Grid>

            <Grid item xl={12} lg={12} md={12} sm={12}>
              <BaseInput
                name="reject"
                value={{
                  reject: {
                    label: t('actionPlan.modal.label'),
                    value: data?.reject,
                  },
                }}
                onChange={onChange}
                errors={errors}
                multiline
                maxRows={3}
              />
            </Grid>
          </Grid>

          <Box sx={styles.containerModalButtons}>
            <Button
              className="cancel"
              onClick={() => {
                handleCloseModal()
              }}
            >
              {t('general.cancel')}
            </Button>
            <LoadingButton
              disabled={!data.reject}
              onClick={() => {
                rejectActionPlan()
              }}
              loading={isLoadingConfirm}
              className="confirm"
            >
              {t('general.confirm')}
            </LoadingButton>
          </Box>
        </>
      </BaseModal>
    </Box>
  )
}

export default Form
